import setDevices from './setDevices';
import setMoreDevices from './setMoreDevices';
import reset from './reset';

export default {
  setDevices,
  setMoreDevices,
  reset,
};
